import "bootstrap/dist/css/bootstrap.min.css";
import "./AyurvedaAboutSection.css";

import img1 from "../images/gall3.webp";
import img2 from "../images/gall5.webp";
import img3 from "../images/gall4.webp";



export default function AyurvedaAboutSection() {

  return (
    <section className="container-fluid ay-about-wrapper " >
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT IMAGE GRID */}
          <div className="col-lg-6 mb-5 mb-lg-0">
            <div className="ay-image-grid">
              <div className="ay-img ay-img-tall">
                <img src={img1} alt="Ayurveda Therapy" />
              </div>

              <div className="ay-img ay-img-tall">
                <img src={img2} alt="Head Massage" />
              </div>

              <div className="ay-img ay-img-small">
                <img src={img3} alt="Herbal Oils" />
              </div>
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-6">
            <div className="ay-about-content">
              <span className="ay-subtitle">
                WHO WE ARE?
              </span>

              <h2 className="ay-title head-font" >
                Sanctuary for Ayurvedic <br /> Healing and Wellness
              </h2>

              <p className="ay-desc para-font justify-text">
               In today’s fast-paced world, true well-being often takes a back seat.Ayur Moksha was born from the belief that traditional Ayurveda holds the key to restoring balance and vitality in modern life.
We revive authentic Ayurvedic practices as practical solutions for preventive care, long-term wellness, conscious living, and specialized care like postnatal recovery for new mothers.Our clinic serves as a bridge between illness and health, offering a calm, personalized environment where healing is respected, not rushed.<br/><br/>
At Ayur Moksha, treatments go beyond symptoms—they nourish body, mind, and lifestyle, guiding people back to a balanced, healthier state. With diverse expertise, innovative thinking, and holistic care, we aim to make a real difference in our patients’ lives,helping them not just feel better, but live better.

              </p>

 

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
